export const DIFFERENCE_KEYS = {
  youtube_videos: "yt_video_id",
};
